import { render, staticRenderFns } from "./ReportExplanationStatisticsPanel.vue?vue&type=template&id=60cc15cb&"
import script from "./ReportExplanationStatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./ReportExplanationStatisticsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports